export enum CodeBustersFeatureFlags {
    TextEditorOverflowWrap = 'CB_TEXT_EDITOR_OVERFLOW_WRAP',
    EnableNewSubmittalPage = 'cb-enable-new-submittal-page',
    DisplayMiddleNameInCandidateProfile = 'cb-display-middle-name-in-candidate-profile',
    DisplayCandidateSubmittalTab = 'cb-candidate-submittals-tab',
    SendToClientUseNewPhoneNumbers = 'cb-send-to-client-use-new-phone-numbers',
    EnableDisplayProfileSpecialtiesInColumns = 'cb-enable-display-profile-specialties-in-columns',
    EnableDisplayUnansweredQuestionsForAllChecklistStatuses = 'cb-enable-display-unanswered-questions-for-all-checklist-statuses',
    OfferOptimizations = 'cb-offers-optimization',
    IsOpenViewDetailsInNewTab = 'cb-offers-grid-view-details-new-tab',
    EnablePinProfileNotes = 'cb-pin-profile-notes',
    EnableExperienceYearDecimal = 'cb-experience-year-decimal',
    EnableSubmittalFormViewOnly = 'cb-enable-submittal-form-view-only',
    CandidateMarginFilterLimit = 'cb-candidates-margin-filter-limit',
    EnableSendToClientModalTemplateType = 'cb-send-to-client-modal-template-type',
    EnableFacilityImportantDetailsUpdate = 'cb-facility-important-details-update',
    EnableSubmittalNoteFlyoutSupportsLineBreaks = 'cb-submittal-note-flyout-supports-line-breaks',
    EnableCandidateGridExportDownload = 'cb-candidate-grid-export-downloard',
    EnableNovaSubmittalCreateApplicationWordDocuments = 'cb-nova-submittal-create-application-word-doc',
    EnableDealsGridRecruiterReviewDefaultFilter = 'cb-enable-deals-grid-recruiter-review-default-filter',
    EnableSubmittalFacilitySearch = 'cb-submittal-facility-search',
    EnableEnvelopeHistoryViewInCandidateProfile = 'show-envelope-history-modal',
    EnableSubmissionsForJobOnRecruiterLiveList = 'cb-expose-submissions-for-job-on-recruiter-live-list',
    EnableExperienceYearDecimalInAddCandidate = 'cb-experience-year-decimal-add-candidate',
    EnableNoteToAmLockBySubmittalStatus = 'cb-note-to-am-lock-by-submittal-status',
    EnableNoteImpersonationActivityTracking = 'cb-note-impersonation-activity-tracking',
    EnableOfferNoteImpersonationActivityTracking = 'cb-offer-note-impersonation-activity-tracking'
}
